import index from "../views/index";
import industry from "../views/industry";
import policy from "../views/policy";
import notice from "../views/notice";
import standard from "../views/standard";
import about from "../views/about";
import Train from "../views/train";
import TrainDetail from "../views/trainDetail";
import exam from "../views/exam";
import query from "../views/query";
import newDetail from "../views/newDetail";
import Login from "../views/login";
import Search from "../views/search";
import Center from "../views/mine/center";
import Profile from "../views/mine/profile";
import Info from "../views/mine/info";
import MyApply from "../views/mine/myApply";
import MyExam from "../views/mine/myExam";
import MyCertificate from "../views/mine/myCertificate";
import contactUs from "../views/contactUs";

export const menuRoutes = [
  {
    path: "/",
    name: "首页",
    component: index,
    meta: {},
  },
  {
    path: "/industry",
    name: "行业动态",
    component: industry,
    meta: {},
  },
  {
    path: "/policy",
    name: "政策法规",
    component: policy,
    meta: {},
  },
  {
    path: "/notice",
    name: "公示公告",
    component: notice,
    meta: {},
  },
  {
    path: "/standard",
    name: "行业标准",
    component: standard,
    meta: {},
  },
  {
    path: "/train",
    name: "在线培训",
    component: Train,
    meta: {},
  },
  {
    path: "/trainDetail/:id",
    name: "培训详情",
    component: TrainDetail,
    meta: {
      hide: true,
    },
  },
  {
    path: "/exam",
    name: "在线考试",
    component: exam,
    meta: {
      requireAuth: false,
    },
  },
  {
    path: "/query",
    name: "证书查询",
    component: query,
    meta: {},
  },
  {
    path: "/about",
    name: "关于我们",
    component: about,
    meta: {},
  },
  {
    path: "/contactUs",
    name: "联系我们",
    component: contactUs,
    meta: {},
  },
  {
    path: "/newDetail/:type/:id",
    name: "详情",
    component: newDetail,
    meta: {
      hide: true,
    },
  },
  {
    path: "/login",
    name: "登录",
    component: Login,
    meta: {
      hide: true,
    },
  },
  {
    path: "/search",
    name: "搜索结果",
    component: Search,
    meta: {
      hide: true,
    },
  },
  {
    path: "/mine",
    name: "center",
    component: Center,
    meta: {
      hide: true,
      requireAuth: true,
    },
    children: [
      { path: "/mine/profile", name: "个人中心", component: Profile },
      { path: "/mine/info", name: "个人信息", component: Info },
      { path: "/mine/myApply", name: "报名记录", component: MyApply },
      { path: "/mine/myExam", name: "考试记录", component: MyExam },
      {
        path: "/mine/myCertificate",
        name: "我的证书",
        component: MyCertificate,
      },
    ],
  },
];
